module.exports = "./img/8de89e09b3b8fc1674168149a38d92b3.jpg";